$(document).ready(function(){

  $('.m-menu').click(function(){
    $('html, body').toggleClass('noscroll');
    $('body').toggleClass('m-menu-open');
  });

  $('.header .nl a').click(function(){
    $('#subForm').toggleClass('open');
    $('#subForm2').toggleClass('open');
  });

  $(".topics").slick({
    infinite: true,
    slidesToShow: 1,
    dots: true,
    adaptiveHeight:true,
    autoplay: true,
    autoplaySpeed: 7000,
  });

  $(".activities .list").slick({
    infinite: true,
    slidesToShow: 3,
    dots: true,
    responsive: [{
      breakpoint: 1000,
      settings: {
          slidesToShow: 2,
      }
    },
    {
      breakpoint: 751,
      settings: {
          slidesToShow: 1,
      }
    }]
  });


  $(".gallery").slick({
    infinite: true,
    slidesToShow: 3,
    dots: true,
    centerMode: true,
    variableWidth: true,
    responsive: [{
      breakpoint: 600,
      settings: {
          slidesToShow: 1,
      }
    }]
  });
  $(".home-gallery").slick({
    infinite: true,
    slidesToShow: 1,
    dots: true,
    centerMode: true,
    variableWidth: false,
    responsive: [{
      breakpoint: 600,
      settings: {
          dots: false,
      }
    }]
  });

  $(".theme-detail-page .list").slick({
    infinite: true,
    slidesToShow: 3,
    dots: true,
    responsive: [{
      breakpoint: 1000,
      settings: {
          slidesToShow: 2,
      }
    },
    {
      breakpoint: 751,
      settings: {
          slidesToShow: 1,
      }
    }]
  });

  // slide to current event on event detail page
  if($('body').hasClass('event-detail-page')){
    var deid = $('.activities').attr('data-active-slide');
    if (deid) {
      // find the slide
      var slideIndex = $('*[data-entry-id="'+deid+'"]').parent().parent().attr('data-slick-index');
      $('.activities .list').slick('slickGoTo',slideIndex);
    }
  }

  $(".embed").fitVids();

  $('.up').click(function(){
    $('html, body').animate({ scrollTop: 0 });
  })


});